/**
 * The canonical MessageCategory values, mirroring the backend enum in
 * `backend/src/api/preferences/schemas.ts` (`MessageCategoryEnum`).
 *
 * The Preferences forms used a free-text input here, with the placeholder
 * "marketing" — lowercase, which the backend enum rejects. Anyone who typed
 * what the placeholder suggested got a 400 (noten-9ss). A closed list is the
 * fix: the control can only produce values the API accepts.
 */
export const MESSAGE_CATEGORY_OPTIONS = [
  'CRITICAL',
  'TRANSACTIONAL',
  'PRODUCT',
  'MARKETING',
] as const;

export type MessageCategoryOption = (typeof MESSAGE_CATEGORY_OPTIONS)[number];

/** Guard for values arriving from outside (URL params, stored filters). */
export function isMessageCategory(value: string): value is MessageCategoryOption {
  return (MESSAGE_CATEGORY_OPTIONS as readonly string[]).includes(value);
}
